import React, { useEffect } from 'react'

import BicoCard from '../BicoCard'
import * as S from './styles'

import { isArray } from 'lodash'
import { Container, Typography } from '@material-ui/core'



export default function CardGrid({ data, term }) {

    return (
        <S.GridContainer>
            <Typography variant="h6" style={{fontSize:'1em'}}>
                {term}
            </Typography>
            <S.CardsWrapper>
                {isArray(data) && data.map((bic) =>
                    <BicoCard
                        dataBico={bic}
                    />)}
            </S.CardsWrapper>
        </S.GridContainer>



    )
}